module.exports = __webpack_public_path__ + "static/img/bg_Sky_1.fea6516d.jpg";